import React from "react";
import { Button } from "reactstrap";

/**
 * Formats links with line breaks for display
 * @param {string} links - Comma-separated links string
 * @returns {React.Fragment} Formatted links with line breaks
 */
const formatLinks = (links) => {
    if (!links) return "";
    return links.split(",").map((link, i) => (
        <React.Fragment key={i}>
            {link.trim()}
            <br />
        </React.Fragment>
    ));
};

/**
 * Transforms a single store handle item for table display
 * @param {Object} handle - Store handle object from API
 * @param {Function} onEdit - Edit handler function
 * @param {Function} onDelete - Delete handler function
 * @returns {Object} Transformed store handle object
 */
export const transformStoreHandleItem = (handle, onEdit, onDelete) => ({
    ...{ id: handle.id, name: handle.name, domain: handle.domain, store: handle.store, is_active: handle.is_active },
    handle: formatLinks(handle.handle),
    hotdeals_handle: formatLinks(handle.hotdeals_handle),
    others_links: handle.website_urls || '',
    status: handle.is_active ? (
        <span className="btn btn-outline-success">Yes</span>
    ) : (
        <span className="btn btn-outline-danger">No</span>
    ),
    action: (
        <span>
            <Button
                color="success"
                onClick={() => onEdit(handle.id, handle.name, handle.handle, handle.hotdeals_handle, handle.domain, handle.store, handle.is_active)}
                className="btn btn-primary waves-effect waves-light mt-1"
                data-toggle="modal"
                data-target="#myModal"
            >
                EDIT
            </Button>
            &nbsp;&nbsp;
            <Button
                color="danger"
                onClick={() => onDelete(handle.id)}
                className="btn btn-danger waves-effect waves-light mt-1"
                data-toggle="modal"
                data-target="#myModal"
            >
                DELETE
            </Button>
        </span>
    )
});

/**
 * Transforms array of store handles into DataTable format
 * @param {Array} handles - Array of store handle objects from API
 * @param {Array} columns - Table column configuration
 * @param {Function} onEdit - Edit handler function
 * @param {Function} onDelete - Delete handler function
 * @returns {Object} DataTable formatted object with columns and rows
 */
export const transformStoreHandlesToTableData = (handles, columns, onEdit, onDelete) => {
    const rows = handles.map(handle => transformStoreHandleItem(handle, onEdit, onDelete));

    return {
        columns,
        rows
    };
};

